export const CHANGE_CONTROL_PANEL_SITE = 'controlPanel.CHANGE_CONTROL_PANEL_SITE';
export const CHANGE_CONTROL_PANEL_PRODUCT = 'controlPanel.CHANGE_CONTROL_PANEL_PRODUCT';
export const CHANGE_CONTROL_PANEL_CATALOG = 'controlPanel.CHANGE_CONTROL_PANEL_CATALOG';
